import { Layout, Menu,} from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { HomeFilled,BankOutlined} from '@ant-design/icons';
import Colors from '../assets/themes/colors';
import { appIdentifier, getLocal } from '../globalFunctions/api';
import { BsBuilding } from "react-icons/bs";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { FaSitemap,FaChalkboardTeacher } from "react-icons/fa";
import { RiAdminLine} from "react-icons/ri";
import { GiArchiveResearch} from "react-icons/gi";

const {  Sider } = Layout;
const { SubMenu } = Menu;


function GlobalSider(props) {
    const {currentPage, currentSub} = props
    const navigate = useNavigate();

    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 


  return (
    <Sider
    theme='light'
    breakpoint="lg"
    width={260}
    collapsedWidth="0"
    onBreakpoint={broken => {
        console.log(broken);
    }}
    onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
    }}
    
    
>


    <Menu mode="inline" 
       
        defaultSelectedKeys={[currentPage]}  
        defaultOpenKeys={[currentSub]}
        onSelect={({item, key, keyPath, selectedKeys, domEvent} )=>{console.log('key is',key)}} >

        <Menu.Item key="mnghome"  style={{marginTop:0,}} onClick={()=> navigate('/mnghome')} icon={<HomeFilled />} >
        الرئيسية
        </Menu.Item>
        {
            localUserType==='main'&&
            <Menu.Item key="unviversities"  style={{marginTop:0,}} onClick={()=> navigate('/unviversities')} icon={<BsBuilding style={{fontSize:18}} />} >
            ادارة الجامعات
            </Menu.Item>
        }

        {
           ( localUserType==='university' || localUserType === 'main')&&
            <Menu.Item key="colleges"  style={{marginTop:0,}} onClick={()=> navigate('/colleges')} icon={<MdOutlineMapsHomeWork style={{fontSize:18}} />} >
            ادارة الكليات
            </Menu.Item>
        }

        {
            (localUserType==='college' || localUserType === 'main')&&
            <Menu.Item key="departs"  style={{marginTop:0,}} onClick={()=> navigate('/departs')} icon={<FaSitemap style={{fontSize:18}} />} >
            ادارة الاقسام
            </Menu.Item>
        }

        {
           localUserType==='depart'&&<Menu.Item key="infos"  style={{marginTop:0,}} onClick={()=> navigate('/infos')} icon={<FaChalkboardTeacher style={{fontSize:18}} />} >
                ادارة التدريسيين
            </Menu.Item>
        }
        

        {
            localUserType==='depart'&&<Menu.Item key="mngSendToTeacher"  style={{marginTop:0,}} onClick={()=> navigate('/send_to_teacher')} icon={<FaChalkboardTeacher style={{fontSize:18}} />} >
            ارسال البحوث للتدريسيين
            </Menu.Item>
        }

        {
            localUserType==='depart'&&<Menu.Item key="MngThesis"  style={{marginTop:0,}} onClick={()=> navigate('/mng_thesis')} icon={<FaChalkboardTeacher style={{fontSize:18}} />} >
            ادارة البحوث المرسلة
            </Menu.Item>
        }
        
        {
             localUserType !='teacher'&&
             <Menu.Item key="admins"  style={{marginTop:0,}} onClick={()=> navigate('/admins')} icon={<RiAdminLine style={{fontSize:18}} />} >
                ادارة المدراء
            </Menu.Item>
        }
            
        

        {
            localUserType==='teacher'&&<Menu.Item key="MngTeacherThesis"  style={{marginTop:0,}} onClick={()=> navigate('/mng_teacher_thesis')} icon={<GiArchiveResearch style={{fontSize:18}} />} >
            ادارة البحوث المستلمة
            </Menu.Item>
        }
        

        

    
    </Menu>


</Sider>
  )
}

export default GlobalSider